<sew-tab-bar hierarchy="sub">
    @if (!customTabs) {
        @if (groups && groups.length > 1) {
            <sew-tab-bar-item
                [name]="'GROUP_TOGGLE.SELECT_ALL' | translate"
                icon="drive-motor"
                [selected]="!selectedGroup"
                (click)="selectGroup(undefined)"
            ></sew-tab-bar-item>
        }
        @for (group of groups; track group) {
            <sew-tab-bar-item
                [selected]="selectedGroup === group || groups?.length === 1"
                name="{{ group.rowData.title }}"
                icon="{{ group.rowData.iconName }}"
                (click)="selectGroup(group)"
            ></sew-tab-bar-item>
        }
    } @else {
        @for (customTab of customTabs; track customTab) {
            <sew-tab-bar-item
                [name]="customTab.textKey | translate"
                [selected]="customTab.selected"
                (click)="selectCustomTab(customTab.index)"
            >
            </sew-tab-bar-item>
        }
    }
</sew-tab-bar>
